import Image from 'next/legacy/image'
import { Fragment } from 'react'
import {
  AnalysisComponentDetailMetrics,
  CAF_ANALYSIS_TYPE_MAP,
  ComplexityDetailItem,
} from '../../../../../model/caf.interface'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { ICON_CHEVRON_RIGHT_GRAY } from '../../../../../modules/svg/svg'
import urls from '../../../../../modules/urls'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import Accordion from '../../common/Accordion'
import AccordionContainer from '../../highlight/AccordionContainer'

const ComplexityCompoundAccordion = ({ data }: { data: AnalysisComponentDetailMetrics }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const router = useAppRouter()
  const isWebview = useIsWebview()
  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const { lessonId, tab, componentId, metricTag, metricIndex } = router.query
  const { navigate } = useWebviewNavigation()
  const goToDetailPage = (metricId, level_tag, title) => () => {
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AIComplexityMetricDetailActivity, {
        metricId,
        error_tag: level_tag,
      })
    } else if (isMobile) {
      navigate({ url: urls.webview.caf.analysis.detail(CAF_ANALYSIS_TYPE_MAP[1], metricId, level_tag) })
    } else {
      router.push(
        urls.student.newPortal.lessons.reviewDetail.asCafComplexityMetricDetail(
          lessonId,
          componentId,
          metricTag,
          metricId,
          level_tag,
          title
        )
      )
    }
  }

  const AccordionTitle = ({ detail }) => (
    <div className={`row-auto flex justify-between pr-[4px]`}>
      <span className={`text-[14px] font-medium text-black`}>
        {t(n_caf.complexity['sentence_' + detail.sentence_type])}
      </span>
      <span className="text-14 font-medium text-gray-500">{detail.ratio}%</span>
    </div>
  )

  return (
    <>
      <AccordionContainer>
        {data.details.map((detail: ComplexityDetailItem, idx) => (
          <Accordion
            key={idx}
            title={<AccordionTitle detail={detail} />}
            idx={idx + 1}
            className={'mb-[8px] cursor-pointer'}
          >
            <span className="text-12 text-gray-500">ⓘ {t(n_caf.complexity.sentence_info)}</span>
            <div className="h-16" />
            <div className="cursor-default">
              {detail.sentences?.slice(0, 5).map((item, index) => (
                <Fragment key={item}>
                  <span className="text-14 text-gray-700">{item}</span>
                  <div
                    className={`border-b-${
                      detail.sentences?.length >= 5 && index === 4 ? 0 : detail.sentences?.length - 1 === index ? 0 : 1
                    } my-16 border-gray-100`}
                  />
                </Fragment>
              ))}
            </div>
            <div
              className="row-auto flex cursor-pointer items-center justify-end"
              onClick={goToDetailPage(
                data.metric_id,
                detail.sentence_tag,
                t(n_caf.complexity['sentence_' + detail.sentence_type])
              )}
            >
              <span className="text-14 mr-9 font-medium text-gray-500">{t(n_caf.highlight.viewmore)}</span>
              <Image src={ICON_CHEVRON_RIGHT_GRAY} width={12} height={16} alt="arrow" />
            </div>
          </Accordion>
        ))}
      </AccordionContainer>
    </>
  )
}

export default ComplexityCompoundAccordion
